import {Component, OnDestroy, OnInit} from '@angular/core';
import * as faceapi from '@vladmandic/face-api';
import {FaceApiService} from '../../../../services/face-api/face-api.service';

@Component({
  selector: 'app-face-detection',
  templateUrl: './face-detection.component.html',
  styleUrls: ['../../../../app.component.scss', '../faceapi.component.scss', './face-detection.component.scss']
})
export class FaceDetectionComponent implements OnInit, OnDestroy {
  constructor(public faceApiService: FaceApiService) {
  }

  ngOnInit(): void {
    this.run();
  }

  ngOnDestroy(): void {
    this.faceApiService.stopStream();
  }

  async run() {
    const faceDetectorSelect = document.getElementById('selectFaceDetector') as HTMLSelectElement;
    const inputSizeSelect = document.getElementById('inputSize') as HTMLSelectElement;
    const videoEl = document.getElementById('inputVideo') as HTMLVideoElement;
    this.faceApiService.init(faceDetectorSelect, inputSizeSelect, videoEl);

    // load face detection model
    await this.faceApiService.changeFaceDetector(this.faceApiService.TINY_FACE_DETECTOR);
    this.faceApiService.changeInputSize(128);

    // try to access users webcam and stream the images
    // to the video element
    videoEl.srcObject = await navigator.mediaDevices.getUserMedia({video: {}});
  }

  async onPlay() {
    await this.faceApiService.play(async () => {
      try {
        const options = this.faceApiService.getFaceDetectorOptions();
        const ts = Date.now();
        const result = await faceapi.detectSingleFace(this.faceApiService.videoEl, options);
        this.faceApiService.updateTimeStats(Date.now() - ts);
        if (result) {
          const canvas = document.getElementById('overlay') as HTMLCanvasElement;
          const dims = faceapi.matchDimensions(canvas, this.faceApiService.videoEl, true);
          faceapi.draw.drawDetections(canvas, faceapi.resizeResults(result, dims));
        }
      } catch (e) {
        console.log(':(');
      }
    });
  }
}
